import React, { Component } from 'react';
import Form from "react-jsonschema-form";
import NewImageWidget from '../widgets/NewImageWidget';
import NewFileWidget from '../widgets/NewFileWidget';
import NewSlug from '../widgets/AutoSlug';
import RTEWidget from '../widgets/RichTextEditorWidget';
import CollapsibleField from '../widgets/CollapsibleField';
import { api } from '../../services/rest';
import { connect } from 'react-redux';
import { alertSuccess, alertDanger } from '../../actions/alertActions';
//import { padTime } from '../../services/Formatting';
import '../../styles/less/slider.css';
import { isNullOrUndefined } from 'util';

class ContentEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: null
        };
        this.onSubmit = this.onSubmit.bind(this);
        this.autoSave = this.autoSave.bind(this);
        this.autoSaveSlider = React.createRef();
        this.contentForm = React.createRef();
    }

    componentDidMount() {
        api.get(`/Content/${this.props.client}/${this.props.project}/Edit/${this.props.id}`)
            .then(res => res.data)
            .then(content => {
                var result = null;
                try {
                    const data = JSON.parse(content.data);
                    const schema = JSON.parse(content.schema);
                    const uiSchema = JSON.parse(content.uiSchema);
                    result = { data, schema, uiSchema };
                    //console.log(result);
                }
                catch (err) {
                    //console.log(err);
                    this.props.alertDanger('Sorry! We could not load your content');
                }

                return result;

            })
            .then(content => this.setState({ content: content }));
        this.autoSaveCheck = setInterval(this.autoSave, 10000);
    }

    componentWillUnmount() {
        clearInterval(this.autoSaveCheck );
    }

    autoSave() {
        if (!isNullOrUndefined(this.refs.autoSaveSlider)) {
            if (this.refs.autoSaveSlider.checked) {
                let content = this.state.content;
                content.data = this.refs.contentForm.state.formData;
                this.setState({ content: content });
                let contentString = JSON.stringify(JSON.stringify(this.state.content.data));
                api.put(`/Content/${this.props.client}/${this.props.project}/Edit/${this.props.id}`, contentString)
                    .then(res => {
                        this.props.alertSuccess(`Autosaved`)
                    })
                    .catch(error => {
                        this.props.alertDanger(`Error autosaving`);
                    });
            }
        }
    }

    onSubmit({ formData }) {
        let content = JSON.stringify(JSON.stringify(formData));
        
        api.put(`/Content/${this.props.client}/${this.props.project}/Edit/${this.props.id}`, content)
            .then(res => {
                this.props.alertSuccess(`Your changes have been saved (${new Date()})`)
            })
            .catch(error => {
                this.props.alertDanger(`Your changes could not be saved (${new Date()})`);
            });
    }
    

    render() {
        const log = (type) => console.log.bind(console, type);
        const widgets = { image: NewImageWidget, file: NewFileWidget};
        const fields = { rtf: RTEWidget, collapsible: CollapsibleField, autoSlug: NewSlug };
        
        if (!this.state.content) { return <span>Loading...</span> }
        return (
            <div>
                <div className="sidebar-offset container-fluid">
                    <label className="switch">
                        <input type="checkbox" ref="autoSaveSlider"/>
                        <span className="slider round"></span>
                    <div className="text">Auto Save</div>
                    </label>
                </div>
                <Form
                    ref="contentForm"
                    schema={this.state.content.schema}
                    uiSchema={this.state.content.uiSchema}
                    fields={fields}
                    widgets={widgets}
                    formData={this.state.content.data}
                    onSubmit={this.onSubmit}
                    onError={log("errors")}
                    //onChange = { log ("change") } // log("change") 
            className="mb-lg" />

            </div>
        )
    }
}

export default connect(null, { alertSuccess, alertDanger })(ContentEditor);